import { Component, OnInit } from '@angular/core';
import { FlashController } from 'src/app/flash-payment/flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-operation-error',
  templateUrl: './operation-error.component.html',
  styleUrls: ['../payment-confirmation.component.sass']
})
export class OperationErrorComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
